<template>
  <div id="app">
    <SiteHeader 
      :mobileOpen="mobileOpen"
      :openSubmenus="openSubmenus"
      @toggleMobile="toggleMobile"
      @toggleSubmenu="toggleSubmenu"
    />
    <main>
      <router-view />
    </main>
    
    <SiteFooter />
  </div>
</template>

<script>
import SiteFooter from './components/Footer.vue'
import SiteHeader from './components/Header.vue'
export default {
  name: 'App',
  components: { SiteFooter, SiteHeader },
  data() {
    return {
      mobileOpen: false,
      openSubmenus: {}
    }
  },
  methods: {
    toggleMobile() {
      this.mobileOpen = !this.mobileOpen;
    },
    toggleSubmenu(key) {
      this.openSubmenus[key] = !this.openSubmenus[key];
    },
    isOpen(key) {
      return !!this.openSubmenus[key];
    }
  }
}

</script>

<style lang="scss">
:root {
  --font-sans: 'Montserrat', 'Nunito Sans', system-ui;
}

html,
body {
  font-family: var(--font-sans);
  color: #222;
  overflow-x: hidden; 
  margin: 0;
  padding: 0;
}

main {
  min-height: 60vh;
}

</style>